
export const GetPathWithoutMeCall = () => {
    return [
        "/third-party-questionnaire",
        "/third-party-questionnarie",
        "/third-party-questionnaire/success",
        "/third-party-questionnarie/success",
        "/not-found"
    ]
};

export const GetAllPublicPath = () => {
    return [
        "/",
        ...GetPathWithoutMeCall()
    ]
};